import { SoccerFieldIcon } from './SoccerFieldIcon';

/**
 * author: GreenTurtwig
 * id C24D4262-700B-46E1-82C1-01449C16205E
 * name soccer-field
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/soccer-field.svg
 * tags
 * - Sport 
 */
export const FootballPitchIcon = SoccerFieldIcon;
export default FootballPitchIcon